import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['replacer', 'image']
  static values = { background: String, kind: String }
  static classes = ['image']

  connect = () => {
    if (this.isHidden) this.element.remove()
  }

  show = (event) => {
    if (!event.target.files.length) return

    const image = this.createImage(event.target.files.item(0))

    this.replacerTargets.forEach((replacer) => {
      if (this.hasImageTarget) {
        replacer.replaceChild(image, this.imageTarget)
      }
      else if (this.backgroundValue) {
        replacer.style.backgroundImage = `${this.backgroundValue} url("${image.src}")`
      }
      else {
        replacer.appendChild(image)
      }
    })
  }

  createImage = (file) => {
    const image = new Image(300, 300)
    image.src = URL.createObjectURL(file)
    image.dataset.thumbnailTarget = 'image'
    image.classList.add(...this.imageClasses)

    return image
  }

  get isHidden() {
    return (this.element.offsetParent === null)
  }
}
